var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: {
      'activity-wrapper': true,
      'activity-wrapper-scroll': _vm.allowScroll,
      isDesktopAAActivity: _vm.isAAActivity && !_vm.isMobile
    },
    style: Object.assign({
      padding: _vm.isMobile ? '25px 75px' : '25px 50px'
    }, _vm.customStyle)
  }, [_vm._t("default")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }